// 财务接口

import request from '../../utils/request'
import { UrlSearch } from "../../utils/UrlSearch";
const shopTitle = UrlSearch().shop;
let shopName ;
if(shopTitle){
    let index = shopTitle.indexOf('.');
    if(index>0){
        shopName = shopTitle.substring(0,index);
    }else{
        shopName = shopTitle;
    }
  
  }
// 财务 - 流水 列表
export function getTransaction(params){
    params.shopName = shopName;
    return request({
        url:'get-transaction',
        method:'POST',
        params:params
    })
}
// 流水 详情
export function getTransactionDetail(params){
    params.shopName = shopName;
    return request({
        url:'get-transaction-detail',
        method:'POST',
        params:params
    })
}

// 账单
export function getBill(params){
    params.shopName = shopName;
    return request({
        url:'get-bill',
        method:'POST',
        params:params
    })
}

// 充值订单
export function getCustomerBill(params){
    params.shopName = shopName;
    return request({
        url:'get-customer-bill',
        method:'POST',
        params:params
    })
}

export function docheckout(params){
    params.shopName = shopName;
    return request({
        url:'do-check-out',
        method:'POST',
        params:params
    })
}

// 我的价格
export function getMyPrice(params){
    params.shopName = shopName;
    return request({
        url:'get-my-price',
        method:'POST',
        params:params
    })
}


// WEBPACK FOOTER //
// ./src/components/views/api/finance.js